import { siteConfig } from '../data/config';

export function getCheckoutHref(): string {
  return siteConfig.checkoutUrl || '#offer';
}

export function formatPrice(): string | null {
  if (siteConfig.price === null) return null;
  return `${siteConfig.currencySymbol}${siteConfig.price.toFixed(2)} ${siteConfig.currencyCode}`;
}
